import { CONFIG_KEYS, DEFAULT_ALGOLIA_CONFIG } from '@algolia-search/consts';
import type { AlgoliaFacet, AlgoliaSorting } from '@algolia-search/types';
import { computed } from '@nuxtjs/composition-api';
import { defineStore } from 'pinia';

import { tryJsonParse } from '~/diptyqueTheme/helpers/tryParse';
import type { StoreConfig } from '~/modules/GraphQL/types';
import { useConfigStore } from '~/stores';

export const useAlgoliaConfigStore = defineStore('algoliaStoreConfig', () => {
  const { storeConfig } = useConfigStore();

  const getConfigValue = (config: StoreConfig, key: keyof typeof CONFIG_KEYS) => {
    const configKey = CONFIG_KEYS[key];
    return config[configKey] || DEFAULT_ALGOLIA_CONFIG[configKey];
  };

  return {
    autocompleteDebounce: computed(() => Number(getConfigValue(storeConfig, 'autocompleteDebounce'))),
    autocompleteMinimumChars: computed(() => Number(getConfigValue(storeConfig, 'autocompleteMinimumChars'))),
    productsSuggestionsCount: computed(() => Number(getConfigValue(storeConfig, 'productsSuggestionsCount'))),
    categoriesSuggestionsCount: computed(() => Number(getConfigValue(storeConfig, 'categoriesSuggestionsCount'))),
    queriesSuggestionsCount: computed(() => Number(getConfigValue(storeConfig, 'queriesSuggestionsCount'))),
    sorts: computed(() => tryJsonParse<Record<string, AlgoliaSorting>>(getConfigValue(storeConfig, 'sorts'), 'Algolia Sorting')),
    facets: computed(() => tryJsonParse<Record<string, AlgoliaFacet>>(getConfigValue(storeConfig, 'facets'), 'Algolia Facets')),
    maxValuesPerFacet: computed(() => Number(getConfigValue(storeConfig, 'maxValuesPerFacet'))),
    recentSearchesCount: computed(() => Number(getConfigValue(storeConfig, 'recentSearchesCount')))
  };
});
